import { createSharedComposable } from '@vueuse/core';
import { Toast } from 'patsnap-biz';
import { setupI18n } from '@eureka/shared/locales/i18n';

export const useLimitReach = createSharedComposable(() => {
  const { t } = setupI18n();

  const showLimitReached = () => {
    Toast({
      type: 'error',
      message: t('limitReach.toast'),
    });
  };

  return {
    showLimitReached,
  };
});
